export default __webpack_public_path__ + "static/media/catLoading.9c63a192.svg";